import React from "react";

interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  label?: string;
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = "md",
  label,
  className = "",
}) => {
  const sizeClass = size === "lg" ? "tf-spinner tf-spinner-lg" : "tf-spinner";
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 ${className}`}
      role="status"
      aria-live="polite"
    >
      <div className={sizeClass} />
      {label && <p className="text-sm text-ink-muted">{label}</p>}
    </div>
  );
};

export default Spinner;
